<template>
  <div class="content">
    <div class="text1">{{ detail.name }}</div>
    <div class="text2">发文字号: {{ detail.fwzh }}</div>
    <div class="text2">发布机构: {{ detail.fbjg }}</div>
    <div class="text2">发布时间: {{ detail.publictime }}</div>
    <div class="text3" v-html="detail.content"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      policyId: '',
      detail: {},
    };
  },
  created() {
    this.policyId = this.$route.query.policyId;
    console.log('this.policyId',this.policyId);
    this.getDetail();
  },
  mounted() {
  },

  methods: {
    getDetail(){
      const url = '/dev-api/sqzd/policy/queryPolicyContent';
      this.$httpApi.post(url, {policyId: this.policyId}).then((r) => {
          this.detail = r.data;
          console.log('this.detail',this.detail);
      })
      .catch((e) => { });
    }
  },
};
</script>
<style lang='scss' scoped>
.content{
  padding:10px 20px;
  margin:0 auto;
  .text1{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }
  .text2{
    color: #949393;
    margin-top: 10px;
    font-size: 14px;
  }
  .text3{
    margin-top:10px;

  }

}
::v-deep{
  img {
    width: 100%;
  }
}

</style>
